import styled, { css } from 'styled-components';

const Button = styled.button`
  cursor: pointer;
  font-size: 14px;
  display: block;
  padding: 8px 15px;
  border: 1px solid rgb(221, 221, 221);
  background: rgb(238, 238, 238);
  outline: none;
  color: #999;
  user-select: none;

  ${(p) =>
    p.isActive
      ? css`
          background: ${(props) => props.theme.colors.blue};
          color: white;
          border-color: ${(props) => props.theme.colors.blue};
          font-weight: bold;
        `
      : ''}

  &:hover {
    background: ${(props) => props.theme.colors.blue};
    color: white;
  }
`;

export default Button;
